var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.original.nombre)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":"green lighten-4"}},[_vm._v(" Datos del cliente "+_vm._s(_vm.original.nombre)+" ")]),_c('v-expansion-panel-content',[_c('Formulario')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }